<template>
  <div>
    <a-spin :spinning="spinning.details">
      <div class="drivasst-details">
        <span class="drivasst-name">{{schooldetails.drivschname}}</span>
        <a-button icon="close" style="float:right;margin-left:20px" @click="close()">关闭</a-button>
        <a-button type="primary" style="float:right;display:none">
          下载详情
          <a-icon type="file-word" />
        </a-button>
        <a-row style="margin:15px 0 15px 20px">
          <a-col :span="8">
            <div class="drivasst-details-keyvalue">
              <span class="drivasst-details-key">驾校名称 :</span>
              <span class="drivasst-details-value">{{schooldetails.drivschname}}</span>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="drivasst-details-keyvalue">
              <span class="drivasst-details-key">驾校简称 :</span>
              <span class="drivasst-details-value">{{schooldetails.drivschshtname}}</span>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="drivasst-details-keyvalue">
              <span class="drivasst-details-key">驾校地址 :</span>
              <span class="drivasst-details-value">{{schooldetails.drivschadress}}</span>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="drivasst-details-keyvalue">
              <span class="drivasst-details-key">驾协ID :</span>
              <span class="drivasst-details-value">{{schooldetails.drivasstid}}</span>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="drivasst-details-keyvalue">
              <span class="drivasst-details-key">驾校ID :</span>
              <span class="drivasst-details-value">{{schooldetails.drivschid}}</span>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="drivasst-details-keyvalue">
              <span class="drivasst-details-key">省代码 :</span>
              <span class="drivasst-details-value">{{schooldetails.provice}}</span>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="drivasst-details-keyvalue">
              <span class="drivasst-details-key">城市代码 :</span>
              <span class="drivasst-details-value">{{schooldetails.city}}</span>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="drivasst-details-keyvalue">
              <span class="drivasst-details-key">区县代码 :</span>
              <span class="drivasst-details-value">{{schooldetails.county}}</span>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="drivasst-details-keyvalue">
              <span class="drivasst-details-key">联系人名称 :</span>
              <span class="drivasst-details-value">{{schooldetails.contactsname}}</span>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="drivasst-details-keyvalue">
              <span class="drivasst-details-key">联系人邮箱 :</span>
              <span class="drivasst-details-value">{{schooldetails.contactsemail}}</span>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="drivasst-details-keyvalue">
              <span class="drivasst-details-key">联系人手机 :</span>
              <span class="drivasst-details-value">{{schooldetails.contactsmobile}}</span>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="drivasst-details-keyvalue">
              <span class="drivasst-details-key">联系人电话 :</span>
              <span class="drivasst-details-value">{{schooldetails.contactsphone}}</span>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="drivasst-details-keyvalue">
              <span class="drivasst-details-key">财务人名称 :</span>
              <span class="drivasst-details-value">{{schooldetails.fincontactsname}}</span>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="drivasst-details-keyvalue">
              <span class="drivasst-details-key">财务人联系手机 :</span>
              <span class="drivasst-details-value">{{schooldetails.finacontactsmobile}}</span>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="drivasst-details-keyvalue">
              <span class="drivasst-details-key">财务人联系邮箱 :</span>
              <span class="drivasst-details-value">{{schooldetails.fincontactsemail}}</span>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="drivasst-details-keyvalue">
              <span class="drivasst-details-key">财务人联系电话 :</span>
              <span class="drivasst-details-value">{{schooldetails.fincontactsphone}}</span>
            </div>
          </a-col>
          <!-- <a-col :span='8'>
            <div class="drivasst-details-keyvalue">
              <span class="drivasst-details-key">创建人ID : </span>
              <span class="drivasst-details-value">{{schooldetails.inputopr}}</span>
            </div>
          </a-col>
          <a-col :span='8'>
            <div class="drivasst-details-keyvalue">
              <span class="drivasst-details-key">创建时间 : </span>
              <span class="drivasst-details-value">{{schooldetails.credatetime}}</span>
            </div>
          </a-col>
          <a-col :span='8'>
            <div class="drivasst-details-keyvalue">
              <span class="drivasst-details-key">修改时间 : </span>
              <span class="drivasst-details-value">{{schooldetails.moddatetime}}</span>
            </div>
          </a-col>
          <a-col :span='8'>
            <div class="drivasst-details-keyvalue">
              <span class="drivasst-details-key">修改人 : </span>
              <span class="drivasst-details-value">{{schooldetails.modopr}}</span>
            </div>
          </a-col>-->
        </a-row>
      </div>
    </a-spin>
    <a-divider />
    <a-spin :spinning="spinning.accum">
      <div class="accum-data">
        <span class="span-title">累计数据</span>
        <a-row type="flex" justify="space-around" style="margin-bottom:40px">
          <a-col :span="5">
            <div class="accum-title">交易总额</div>
            <div class="accum-number">
              {{accumData.tradeamttotal}}
              <font style="font-size:16px">元</font>
            </div>
          </a-col>
          <a-col :span="5">
            <div class="accum-title">培训合同数</div>
            <div class="accum-number">{{accumData.contractnum}}</div>
          </a-col>
          <a-col :span="5">
            <div class="accum-title">预付培训费金额</div>
            <div class="accum-number">
              {{accumData.superviseamttotal}}
              <font style="font-size:16px">元</font>
            </div>
          </a-col>
        </a-row>
      </div>
    </a-spin>
    <a-divider />
    <a-spin :spinning="spinning.account">
      <span class="drivsch-name">账户信息</span>
      <a-row style="margin-top:20px" type="flex">
        <a-col :span="8">
          <div class="key-value">
            <span class="key">自有账户号 :</span>
            <span class="value">{{accountInfo.mngselfacn}}</span>
          </div>
        </a-col>
        <a-col :span="8">
          <div class="key-value">
            <span class="key">自有户余额 :</span>
            <span class="value">{{accountInfo.mngselfbal}}</span>
          </div>
        </a-col>
        <a-col :span="8">
          <div class="key-value">
            <span class="key">自有户用户名称 :</span>
            <span class="value">{{accountInfo.mngselfname}}</span>
          </div>
        </a-col>
        <a-col :span="8">
          <div class="key-value">
            <span class="key">自有开户行名称 :</span>
            <span class="value">{{accountInfo.mngselfopbknm}}</span>
          </div>
        </a-col>
        <a-col :span="8">
          <div class="key-value">
            <span class="key">自有账户开户日期 :</span>
            <span class="value">{{accountInfo.mngselfopdate}}</span>
          </div>
        </a-col>
        <a-col :span="8">
          <div class="key-value">
            <span class="key">预付培训费账户号 :</span>
            <span class="value">{{accountInfo.spvsacn}}</span>
          </div>
        </a-col>
        <a-col :span="8">
          <div class="key-value">
            <span class="key">预付培训费账户余额 :</span>
            <span class="value">{{accountInfo.spvsbal}}</span>
          </div>
        </a-col>
        <a-col :span="8">
          <div class="key-value">
            <span class="key">预付培训费账户名称 :</span>
            <span class="value">{{accountInfo.spvsname}}</span>
          </div>
        </a-col>
        <a-col :span="8">
          <div class="key-value">
            <span class="key">预付培训费账户开户行名称 :</span>
            <span class="value">{{accountInfo.spvsopbknm}}</span>
          </div>
        </a-col>
        <a-col :span="8">
          <div class="key-value">
            <span class="key">预付培训费账户开户日期 :</span>
            <span class="value">{{accountInfo.spvsopdate}}</span>
          </div>
        </a-col>
        <a-col :span="8">
          <div class="key-value">
            <span class="key">自有户用户地址 :</span>
            <span class="value">{{accountInfo.mngselfaddr}}</span>
          </div>
        </a-col>
        <a-col :span="8">
          <div class="key-value">
            <span class="key">预付培训费用户地址 :</span>
            <span class="value">{{accountInfo.spvsaddr}}</span>
          </div>
        </a-col>
      </a-row>
    </a-spin>
  </div>
</template>
<script>
export default {
  name: "DSchool",
  props: ["parameters"],
  data() {
    return {
      schooldetails: {},
      accumData: {},
      spinning: {
        details: true,
        accum: true,
        account: false
      },
      accountInfo: {},
    };
  },
  created() {
    this.getSchoolDetails();
    this.getAccumData();
    this.getAccountInfo();
  },
  methods: {
    getSchoolDetails() {
      const that = this;
      that.spinning.details = true;
      that.schooldetails = {};
      const reqData = {
        drivasstid: this.parameters.drivasstid,
        drivschid: this.parameters.drivschid
        // "drivasstid": 1,
        // "drivschid": 1
      };
      this.$http.post(
        this.$marco.api.schoolDetails,
        reqData,
        data => {
          that.spinning.details = false;
          this.$log.success(JSON.stringify(data));
          that.schooldetails = data;
        },
        errorDesc => {
          that.spinning.details = false;
          this.$log.normal(JSON.stringify(errorDesc));
        },
        error => {
          that.spinning.details = false;
          this.$log.error(JSON.stringify(error));
        }
      );
    },
    getAccumData() {
      //获取累计数据，包含交易总额、培训合同数、通过率、监管总金额
      const that = this;
      that.accumData = {};
      that.spinning.accum = true;
      const reqData = {
        drivasstid: this.parameters.drivasstid,
        drivschid: this.parameters.drivschid
      };
      this.$http.post(
        this.$marco.api.accumData,
        reqData,
        data => {
          // this.$log.success('累计数据---------'+JSON.stringify(data));
          that.spinning.accum = false;
          that.accumData = data;
        },
        errorDesc => {
          that.spinning.accum = false;
          this.$log.normal("累计数据---------" + JSON.stringify(errorDesc));
        },
        error => {
          that.spinning.accum = false;
          this.$log.error("累计数据---------" + JSON.stringify(error));
        }
      );
    },
    close() {
      this.$emit("onClose");
    },
    getAccountInfo() {
      const that = this;
      that.spinning.account = true;
      that.tableData = [];
      const reqData = {
        drivschid: that.parameters.drivschid,
        currpage: 1,
        recnumperpage: 1
      };
      that.$http.post(
        that.$marco.api.accountList,
        reqData,
        data => {
          that.spinning.account = false;
          this.$log.success(JSON.stringify(data));
          if (data.pagelist[0]) {
            that.accountInfo = data.pagelist[0];
          }
        },
        errorDesc => {
          that.spinning.account = false;
          this.$log.normal(JSON.stringify(errorDesc));
        },
        error => {
          that.spinning.account = false;
          this.$log.error(JSON.stringify(error));
        },
        that
      );
    }
  }
};
</script>
<style scoped>
.drivasst-name {
  font-size: 20px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.847058823529412);
}
.drivasst-details-keyvalue {
  margin-bottom: 10px;
}
.drivasst-details-key {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.847);
}
.drivasst-details-value {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.647058823529412);
}
.accum-data {
  margin-top: 30px;
}
.span-title {
  font-family: "PingFang-SC-Bold", "PingFang SC Bold", "PingFang SC";
  font-weight: 700;
  font-style: normal;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.847058823529412);
  text-align: left;
  line-height: 24px;
}
.accum-title {
  margin-top: 15px;
  font-size: 14px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.427450980392157);
}
.accum-number {
  font-size: 26px;
  line-height: 30px;
  color: rgba(0, 0, 0, 0.847058823529412);
}
.train-project {
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.647058823529412);
}
.train-pass-title {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.427450980392157);
  padding-top: 15px;
}
.train-pass-percent {
  font-size: 28px;
  color: rgba(0, 0, 0, 0.647058823529412);
}
.drivsch-name {
  font-size: 20px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.847058823529412);
}
.key-value {
  margin-bottom: 20px;
  margin-left: 20px;
}
.key {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.847);
}
.value {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.647058823529412);
}
</style>